var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.84807 13.8186L7.24576 9.42091C7.50978 9.1569 7.64178 9.0249 7.794 8.97544C7.92789 8.93193 8.07213 8.93193 8.20602 8.97544C8.35824 9.0249 8.49025 9.15691 8.75426 9.42091L13.1226 13.7893M9.33334 10L11.2458 8.08758C11.5098 7.82357 11.6418 7.69156 11.794 7.6421C11.9279 7.5986 12.0721 7.5986 12.206 7.6421C12.3582 7.69156 12.4902 7.82357 12.7543 8.08758L14.6667 10M6.66668 6C6.66668 6.73638 6.06972 7.33333 5.33334 7.33333C4.59696 7.33333 4.00001 6.73638 4.00001 6C4.00001 5.26362 4.59696 4.66667 5.33334 4.66667C6.06972 4.66667 6.66668 5.26362 6.66668 6ZM4.53334 14H11.4667C12.5868 14 13.1468 14 13.5747 13.782C13.951 13.5903 14.2569 13.2843 14.4487 12.908C14.6667 12.4802 14.6667 11.9201 14.6667 10.8V5.2C14.6667 4.0799 14.6667 3.51984 14.4487 3.09202C14.2569 2.71569 13.951 2.40973 13.5747 2.21799C13.1468 2 12.5868 2 11.4667 2H4.53334C3.41324 2 2.85319 2 2.42536 2.21799C2.04904 2.40973 1.74308 2.71569 1.55133 3.09202C1.33334 3.51984 1.33334 4.0799 1.33334 5.2V10.8C1.33334 11.9201 1.33334 12.4802 1.55133 12.908C1.74308 13.2843 2.04904 13.5903 2.42536 13.782C2.85319 14 3.41324 14 4.53334 14Z",
    stroke: "#1570EF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.aee2f3ae79adcf602aad81c5ce626404.svg";
export { ForwardRef as ReactComponent };